import { defaultLocale } from "i18n";
import i18next from "i18next";

import { trpcClient } from "src/trpc";
import { type IsomorphicRequestData } from "src/types";

export const isomorphicRequestDataRef: {
  current: IsomorphicRequestData | undefined;
} = {
  current: undefined,
};

export const updateIsomorphicRequestData = (
  payload: Partial<IsomorphicRequestData>,
) => {
  if (!isomorphicRequestDataRef.current) {
    isomorphicRequestDataRef.current = {
      trpc: trpcClient,
      i18n: i18next,
      locale: defaultLocale,
    };
  }

  isomorphicRequestDataRef.current = {
    ...isomorphicRequestDataRef.current,
    ...payload,
  };
};
